import script from "./loginGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./loginGuide.vue?vue&type=script&setup=true&lang=js"

import "./loginGuide.vue?vue&type=style&index=0&id=ef3bb044&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef3bb044"]])

export default __exports__